module.exports = __webpack_public_path__ + "media/images/icons/SVG/057-5f65c76eec5efc8786ebe88072a50d15.svg";